import {
  FC,
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation } from "react-router-dom";
import cs from "classnames";
import useScreenSize from "hooks/useScreenSize";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import styles from "./styles.module.scss";
import { getMainMenuItems, menuItems } from "./constants";
import HeaderV2 from "layouts/v2/Header";
import { useAppSelector } from "hooks/store";
import { selectUserData } from "store/auth/authSlice";
import useIsProductionApp from "hooks/useIsProductionApp";

interface IProps {
  children?: ReactNode;
}

const SidebarHeader: FC<IProps> = ({ children }) => {

  const isProductionApp = useIsProductionApp();
  
  const userAuth = useAppSelector(selectUserData);
  
  const { pathname, hash } = useLocation();

  const screenSize = useScreenSize();
  const isMobileView = useMemo(
    () => screenSize !== "2xl" && screenSize !== "xl",
    [screenSize]
  );

  const anchorRef = useRef(null);

  useEffect(() => {
    if (anchorRef.current) {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    }
  }, [hash]);

  const onCheckPageTitle = useCallback(() => {

    const menus = getMainMenuItems({
      inventory: userAuth.inventory.value,
      roles: userAuth.roles,
      third_party_provider: userAuth.dealerV2.third_party_provider,
      isProductionApp: isProductionApp,
      is_lite: userAuth.dealerV2.is_lite
    });

    const { label } = menus.find(({ subMenu, link }) => {
      if (subMenu && !link) {
        const subMenuIndex = subMenu.findIndex(
          ({ link: submenuLink }) =>
            submenuLink.replace(/\?.*/, "") === pathname
        );

        return subMenuIndex !== -1;
      }

      return link === pathname;
    }) || { label: "", subMenu: [], iconSrc: "" };

    return label;
  }, [isProductionApp, pathname, userAuth.dealerV2.third_party_provider, userAuth.inventory.value, userAuth.roles]);

  const [isSidebarClose, setIsSidebarClose] = useState<boolean>(false);
  const [hoverToggleSidebar, setHoverToggleSidebar] = useState<boolean>(false);
  const [pageTitle, setPageTitle] = useState(() => onCheckPageTitle());

  const [isMobileSidebarClose, setIsMobileSidebarClose] = useState<boolean>(true);
  const [hoverToggleMobileSidebar, setHoverToggleMobileSidebar] = useState<boolean>(false);


  useEffect(() => {
    setPageTitle(() => onCheckPageTitle());
  }, [onCheckPageTitle, pathname]);

  return (
    <div
      className={cs(styles.containerLayout, {
        [styles.isSidebarClose]: isMobileView ? isMobileSidebarClose : isSidebarClose,
        // [styles.isHoverSidebar]: hoverToggleSidebar,
      })}
    >      
      {isMobileView ? (
        <Sidebar
          hoverToggleSidebar={hoverToggleMobileSidebar}
          // isMobileView={isMobileView}
          isSidebarClose={isMobileSidebarClose}
          setHoverToggleSidebar={setHoverToggleMobileSidebar}
          setIsSidebarClose={setIsMobileSidebarClose}
          isMobileView={isMobileView}
        />
      ) : (

        <Sidebar
          hoverToggleSidebar={hoverToggleSidebar}
          // isMobileView={isMobileView}
          isSidebarClose={isSidebarClose}
          setHoverToggleSidebar={setHoverToggleSidebar}
          setIsSidebarClose={setIsSidebarClose}
        />
      )}

      {/* <Header pageTitle={pageTitle} setIsSidebarClose={isMobileView ? setIsMobileSidebarClose : setIsSidebarClose} /> */}
      <HeaderV2
        isOpen={isMobileView ? isMobileSidebarClose : isSidebarClose}
        pageTitle={pageTitle}
        setIsSidebarClose={isMobileView ? setIsMobileSidebarClose : setIsSidebarClose}
      />
      <div ref={anchorRef} className={styles.content}>
        <div
          style={{
            flex: 1,
            gridArea: "content",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </div>
        <div
          className="footer"
          style={{
            padding: '10px 15px',
            backgroundColor: 'rgba(000,000,000, 0.1)',
            margin: '15px -22px -24px',
            textAlign: 'center',
            fontSize: 14,
            color: 'rgba(000,000,000, 0.6)',
          }}
        >
          &copy; 2024- {new Date().getFullYear()} VinDrives. All Rights Reserved.
        </div>
      </div>
    </div>
  );
};

export default SidebarHeader;
